import { useState } from "react";

// ----------------------------------------------------------------------

export default function useTabs(defaultValues: string | any) {
  const [currentTab, setCurrentTab] = useState(defaultValues || "");

  return {
    currentTab,
    onChangeTab: (event: any, newValue: string | any) => {
      setCurrentTab(newValue);
    },
    setCurrentTab,
  };
}
